(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .factory('ProgressModal', ProgressModal);

  // @ngInject
  function ProgressModal($q, $timeout, $uibModal) {

    // statuses
    var PENDING = 'pending',
        SUCCESS = 'success',
        FAILURE = 'error';

    return {
      showModal : showModal
    };

    function defaultPercentFn(event) {
      return event && event.loaded / event.total;
    }

    function showModal(promise, config) {
      config = config || {};
      var status = PENDING;
      var percentDone = 0;
      var percentFn = config.percentFn || defaultPercentFn;

      var modal = $uibModal.open({
        size : 'sm',
        templateUrl : 'Util/ProgressModal.tmpl.html',
        controller : function ($scope) {
          $scope.$watch(function () {
            return percentDone;
          }, function (percent) {
            if (!isNaN(percent)) {
              $scope.percent = percent;
            }
          });

          function isStatus(expected) {
            return status === expected;
          }

          $scope.showProgress = config.progress !== false;
          $scope.isPending = _.bind(isStatus, null, PENDING);
          $scope.isSuccess = _.bind(isStatus, null, SUCCESS);
          $scope.isFailure = _.bind(isStatus, null, FAILURE);
          $scope.translationKey = config.translationKey;
        }
      });


      return promise.then(success, failure, progress);

      function deferredClose() {
        return $timeout(function () {
          modal.close();
        }, 1000);
      }

      function success(result) {
        percentDone = 1;
        status = SUCCESS;
        return deferredClose().then(function () {
          return result;
        });
      }

      function failure(reason) {
        status = FAILURE;
        return deferredClose().then(function () {
          return $q.reject(reason);
        });
      }

      function progress(event) {
        percentDone = percentFn(event);
      }
    }
  }

})();
